import PropTypes from 'prop-types';
import React from 'react';
import ReactStars from 'react-stars';

// eslint-disable-next-line import/no-default-export
export default class WidgetStars extends React.Component {
  state = {
    // @ts-expect-error
    value: this.props.value || 1,
  };

  onChange = (value) => {
    // @ts-expect-error
    const { onChange } = this.props;

    this.setState({ value });
    onChange(value);
  };

  render() {
    // @ts-expect-error
    const { schema } = this.props;
    const { value } = this.state;

    return (
      <div>
        <ReactStars
          count={schema.maximum || 5}
          onChange={this.onChange}
          value={value}
          size={24}
          color1={'#96ACBF'}
          color2={'#ffd700'}
          half={false}
        />
      </div>
    );
  }
}

// @ts-expect-error
WidgetStars.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  schema: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};
